import React, { FunctionComponent } from "react";

const SuccessStatusIcon: FunctionComponent = () => (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <circle cx="10" cy="10" r="10" fill="#22C55E" />
        <path
            d="M5.5 10.5L8.5 13.5L14.5 7"
            fill="none"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default SuccessStatusIcon;
